import { useQuery } from "@tanstack/react-query";
import { PostModel } from "common/models/BaseModel";
import { topBooksPerformance } from "./query";
import {
  IMaterialTypeRankingFilter,
  IMemberTypeRankingFilter,
  IMostActiveMembersGridFilter,
  ITopFrequentlyUsedBooksGridFilter,
} from "./types";

export function GetTopFrequentlyUsedBooks(
  postModel: PostModel<ITopFrequentlyUsedBooksGridFilter>,
) {
  return useQuery({
    ...topBooksPerformance.getTopFrequentlyUsedBooks(postModel),
  });
}

export function GetMostActiveMembers(
  postModel: PostModel<IMostActiveMembersGridFilter>,
) {
  return useQuery({
    ...topBooksPerformance.getMostActiveMembers(postModel),
  });
}

export function GetMemberTypeRanking(filter: IMemberTypeRankingFilter) {
  return useQuery({
    ...topBooksPerformance.getMemberTypeRanking(filter),
    enabled: !!filter?.fromDate && !!filter?.toDate,
  });
}

export function GetMaterialTypeRanking(filter: IMaterialTypeRankingFilter) {
  return useQuery({
    ...topBooksPerformance.getMaterialTypeRanking(filter),
    enabled: !!filter?.fromDate && !!filter?.toDate,
  });
}
